import { Injectable } from '@angular/core';
import { EntityCollectionService, EntityServices } from '@ngrx/data';
import { Observable, of } from 'rxjs';
import { catchError, finalize, shareReplay, take } from 'rxjs/operators';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { RegistrationModel } from './registration.model';
import { entityName as registrationEntityName } from './registration.data-service';

/**
 * Loads registration status into the NgRx entity cache so router hooks
 * (needsRegistration) can evaluate NeedsRegistration without visiting /register.
 */
@Injectable({ providedIn: 'root' })
export class RegistrationPrefetchService {
    private readonly registrationDataService: EntityCollectionService<RegistrationModel>;
    private inFlight: Observable<RegistrationModel | null> | null = null;

    constructor(
        entityServices: EntityServices,
        private log: LoggingService
    ) {
        this.registrationDataService =
            entityServices.getEntityCollectionService<RegistrationModel>(
                registrationEntityName
            );
    }

    ensureLoaded$(): Observable<RegistrationModel | null> {
        if (!this.inFlight) {
            this.registrationDataService.clearCache();
            this.inFlight = this.registrationDataService.getByKey('').pipe(
                take(1),
                catchError(err => {
                    this.log.verbose({
                        type: 'RegistrationPrefetchService:ensureLoaded$:failed',
                        err
                    });
                    return of(null);
                }),
                finalize(() => {
                    this.inFlight = null;
                }),
                shareReplay(1)
            );
        }

        return this.inFlight;
    }
}
